import api from './api';

const usersApi = {
  // Récupérer tous les utilisateurs
  getAll: () => {
    return api.get('/users');
  },

  // Récupérer un utilisateur par ID
  getById: (id) => {
    return api.get(`/users/${id}`);
  },

  // Créer un nouvel utilisateur
  create: (data) => {
    return api.post('/users', data);
  },

  // Modifier un utilisateur
  update: (id, data) => {
    return api.put(`/users/${id}`, data);
  },

  // Supprimer un utilisateur
  delete: (id) => {
    return api.delete(`/users/${id}`);
  },

  // Changer le mot de passe
  changePassword: (id, data) => {
    return api.put(`/users/${id}/password`, data);
  },

  // Activer/désactiver le statut responsable
  toggleResponsable: (id, isResponsable) => {
    return api.put(`/users/${id}/responsable`, { is_responsable: isResponsable });
  },

  // Modifier manager_id et dashboard_scope
  updateScope: (id, data) => {
    return api.put(`/users/${id}/scope`, data);
  },

  // Import en masse depuis Excel
  importUsers: (rows) => api.post('/users/import', { rows }),

  // Utilisateurs assignables selon le rôle (responsables de la concession pour les opérateurs)
  getAssignables: () => api.get('/users/assignables'),

  // Concessions associées à un utilisateur prestataire
  getConcessions: (id) => api.get(`/users/${id}/concessions`),
  setConcessions: (id, concession_ids) => api.put(`/users/${id}/concessions`, { concession_ids }),
};

export default usersApi;
